// assets/hero-countdown.js

(function() {
  'use strict';
  
  // Cache DOM elements and values
  let daysEl, hoursEl, minutesEl, secondsEl;
  let targetTime = null;
  let intervalId = null;
  let timerElement = null;
  
  function initCountdown() {
    timerElement = document.getElementById('countdown-timer');
    if (!timerElement) return;
    
    // Get date and time from data attributes
    const dateStr = timerElement.getAttribute('data-date');
    const timeStr = timerElement.getAttribute('data-time');
    
    // Clear any existing interval
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    
    // Validate date and time
    if (!dateStr || !timeStr || dateStr === '' || timeStr === '') {
      timerElement.style.display = 'none';
      return;
    }
    
    // Parse date (YYYY-MM-DD)
    const dateParts = dateStr.split('-');
    if (dateParts.length !== 3) {
      timerElement.style.display = 'none';
      return;
    }
    
    // Parse time (HH:MM)
    const timeParts = timeStr.split(':');
    if (timeParts.length !== 2) {
      timerElement.style.display = 'none';
      return;
    }
    
    // Convert to numbers
    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    const day = parseInt(dateParts[2], 10);
    const hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
    
    // Validate all values
    if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hours) || isNaN(minutes) ||
        month < 0 || month > 11 || day < 1 || day > 31 || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      timerElement.style.display = 'none';
      return;
    }
    
    // Create target date
    const targetDate = new Date(year, month, day, hours, minutes, 0, 0);
    if (isNaN(targetDate.getTime())) {
      timerElement.style.display = 'none';
      return;
    }
    
    targetTime = targetDate.getTime();
    
    // Make sure timer is visible
    timerElement.style.display = '';
    
    // Cache DOM elements
    daysEl = document.getElementById('days');
    hoursEl = document.getElementById('hours');
    minutesEl = document.getElementById('minutes');
    secondsEl = document.getElementById('seconds');
    
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
      timerElement.style.display = 'none';
      return;
    }
    
    // Store previous values to avoid unnecessary updates
    let prevDays = '', prevHours = '', prevMinutes = '', prevSeconds = '';
    
    function updateCountdown() {
      const now = Date.now();
      const distance = targetTime - now;
      
      if (distance <= 0) {
        // Only update if values changed
        if (prevDays !== '00') {
          daysEl.textContent = '00';
          prevDays = '00';
        }
        if (prevHours !== '00') {
          hoursEl.textContent = '00';
          prevHours = '00';
        }
        if (prevMinutes !== '00') {
          minutesEl.textContent = '00';
          prevMinutes = '00';
        }
        if (prevSeconds !== '00') {
          secondsEl.textContent = '00';
          prevSeconds = '00';
        }
        return;
      }
      
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      const daysStr = String(days).padStart(2, '0');
      const hoursStr = String(hours).padStart(2, '0');
      const minutesStr = String(minutes).padStart(2, '0');
      const secondsStr = String(seconds).padStart(2, '0');
      
      // Only update DOM if values actually changed
      if (prevDays !== daysStr) {
        daysEl.textContent = daysStr;
        prevDays = daysStr;
      }
      if (prevHours !== hoursStr) {
        hoursEl.textContent = hoursStr;
        prevHours = hoursStr;
      }
      if (prevMinutes !== minutesStr) {
        minutesEl.textContent = minutesStr;
        prevMinutes = minutesStr;
      }
      if (prevSeconds !== secondsStr) {
        secondsEl.textContent = secondsStr;
        prevSeconds = secondsStr;
      }
    }
    
    // Initial update
    updateCountdown();
    
    // Start interval if not already running
    if (!intervalId) {
      intervalId = setInterval(updateCountdown, 1000);
    }
  }
  
  // Initialize when DOM is ready
  function initialize() {
    initCountdown();
  }
  
  // Handle Shopify section reload (for theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      // Check if this is our section
      if (event.target && event.target.querySelector('#countdown-timer')) {
        // Reinitialize after a small delay
        setTimeout(initCountdown, 100);
      }
    });
    
    // Also reinitialize when section is rendered in the editor
    document.addEventListener('shopify:section:reorder', function(event) {
      if (event.target && event.target.querySelector('#countdown-timer')) {
        setTimeout(initCountdown, 100);
      }
    });
  }
  
  // Listen for section updates via AJAX
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.detail ? event.detail.section : null;
    if (section && section.querySelector && section.querySelector('#countdown-timer')) {
      setTimeout(initCountdown, 100);
    }
  });
  
  // Also listen for variant changes in the theme editor
  document.addEventListener('shopify:section:select', function(event) {
    if (event.target && event.target.querySelector('#countdown-timer')) {
      // Reinitialize when section is selected in the editor
      setTimeout(initCountdown, 100);
    }
  });
  
  // Fallback: reinitialize when DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
  // Clean up on page unload
  window.addEventListener('beforeunload', function() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  });
})();